import { render } from "./AttUser.vue?vue&type=template&id=20368335&scoped=true"
import script from "./AttUser.vue?vue&type=script&lang=js"
export * from "./AttUser.vue?vue&type=script&lang=js"

import "./AttUser.vue?vue&type=style&index=0&id=20368335&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20368335"]])

export default __exports__